import * as helper from './../../../Assets/Js/helper';

export function SoundButton() {
	const element = document.querySelector('.model-videostream-preview-volume');
	const video = document.querySelector('video');

	helper.addClickListener(element, (e: MouseEvent) => {
		e.preventDefault();

		if (helper.hasClass(element, 'off')) {
			helper.removeClass(element, 'off');
			helper.addClass(element, 'on');
			video.muted = false;
		} else {
			helper.removeClass(element, 'on');
			helper.addClass(element, 'off');
			video.muted = true;
		}
	})
}
